import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "OVI KYB", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "seq-reminder-link mb-6" }
const _hoisted_7 = { class: "seq-reminder-link__main" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "seq-badge seq-badge--success me-2" }, "Referral Link", -1)
const _hoisted_9 = { class: "seq-reminder-link__actions" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "seq-kyb-share mb-6"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "seq-kyb-share__title fw-semibold text-gray-800 mb-4" }, "Share Details", -1)
const _hoisted_13 = { class: "seq-profile-form" }
const _hoisted_14 = { class: "seq-profile-row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "seq-profile-label fw-semibold text-gray-800" }, "Title", -1)
const _hoisted_16 = { class: "seq-profile-control" }
const _hoisted_17 = { class: "seq-profile-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "seq-profile-label fw-semibold text-gray-800" }, "Description", -1)
const _hoisted_19 = { class: "seq-profile-control" }
const _hoisted_20 = { class: "seq-profile-row" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "seq-profile-label fw-semibold text-gray-800" }, "Quote", -1)
const _hoisted_22 = { class: "seq-profile-control" }
const _hoisted_23 = { class: "seq-profile-row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "seq-profile-label fw-semibold text-gray-800" }, "Hashtags", -1)
const _hoisted_25 = { class: "seq-profile-control" }
const _hoisted_26 = { class: "seq-profile-row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "seq-profile-label fw-semibold text-gray-800" }, "Share With", -1)
const _hoisted_28 = { class: "seq-profile-control" }
const _hoisted_29 = /*#__PURE__*/_createVNode("option", { value: "" }, "Select platform", -1)
const _hoisted_30 = {
  key: 0,
  class: "d-flex flex-wrap gap-2"
}
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "#"),
    /*#__PURE__*/_createVNode("th", null, "Prospect"),
    /*#__PURE__*/_createVNode("th", { class: "d-none d-lg-table-cell" }, "Accident Protection"),
    /*#__PURE__*/_createVNode("th", null, "Budget"),
    /*#__PURE__*/_createVNode("th", { class: "d-none d-md-table-cell" }, "People"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Philippines")
  ])
], -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createVNode("td", {
  colspan: "6",
  class: "text-center text-muted py-10"
}, " No survey responses yet. Share your referral link to get started. ", -1)
const _hoisted_36 = { class: "ps-4" }
const _hoisted_37 = { class: "text-muted fs-8" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_40 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_41 = { class: "fw-semibold text-gray-800" }
const _hoisted_42 = { class: "text-muted fs-8" }
const _hoisted_43 = { class: "text-muted fs-8" }
const _hoisted_44 = { class: "d-lg-none mt-2" }
const _hoisted_45 = { class: "rating" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-6" }, null, -1)
const _hoisted_47 = { class: "d-none d-lg-table-cell" }
const _hoisted_48 = { class: "rating" }
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-6" }, null, -1)
const _hoisted_50 = { class: "fw-semibold text-gray-800" }
const _hoisted_51 = { class: "text-muted fs-8 d-md-none" }
const _hoisted_52 = { class: "d-none d-md-table-cell" }
const _hoisted_53 = { class: "fw-semibold text-gray-800" }
const _hoisted_54 = { class: "pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Group.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("a", {
              href: _ctx.shareLink,
              target: "_blank",
              class: "fw-semibold seq-reminder-link__url"
            }, _toDisplayString(_ctx.shareLink), 9, ["href"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("button", {
              type: "button",
              class: "seq-share-btn seq-share-btn--copy",
              title: _ctx.copiedKey ? 'Copied!' : 'Copy link',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyLink(_ctx.shareLink)))
            }, [
              _createVNode("i", {
                class: ["fas", _ctx.copiedKey ? 'fa-check' : 'fa-copy']
              }, null, 2)
            ], 8, ["title"]),
            _createVNode("button", {
              type: "button",
              class: ["seq-share-btn seq-share-btn--share", { 'is-active': _ctx.showShareDiv }],
              title: _ctx.showShareDiv ? 'Close share' : 'Share link',
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSharePanel && _ctx.toggleSharePanel(...args)))
            }, [
              _hoisted_10
            ], 10, ["title"])
          ])
        ]),
        (_ctx.showShareDiv)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    _withDirectives(_createVNode("textarea", {
                      rows: "3",
                      class: "seq-profile-input",
                      placeholder: "Title",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sharing.title = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.sharing.title]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _withDirectives(_createVNode("textarea", {
                      rows: "3",
                      class: "seq-profile-input",
                      placeholder: "Description",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.sharing.description = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.sharing.description]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, [
                    _withDirectives(_createVNode("textarea", {
                      rows: "3",
                      class: "seq-profile-input",
                      placeholder: "Quote",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sharing.quote = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.sharing.quote]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, [
                    _withDirectives(_createVNode("textarea", {
                      rows: "3",
                      class: "seq-profile-input",
                      placeholder: "Hashtags",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sharing.hashtags = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.sharing.hashtags]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, [
                    _withDirectives(_createVNode("select", {
                      class: "seq-profile-select mb-3",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.share_socmed = $event))
                    }, [
                      _hoisted_29,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
                        return (_openBlock(), _createBlock("option", {
                          key: network.network,
                          value: network.network
                        }, _toDisplayString(network.name), 9, ["value"]))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.share_socmed]
                    ]),
                    (_ctx.share_socmed)
                      ? (_openBlock(), _createBlock("div", _hoisted_30, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
                            return (_openBlock(), _createBlock(_Fragment, {
                              key: 'share-' + network.network
                            }, [
                              (network.network.toUpperCase() === _ctx.share_socmed.toUpperCase())
                                ? (_openBlock(), _createBlock(_component_ShareNetwork, {
                                    key: 0,
                                    network: network.network,
                                    url: _ctx.shareLink,
                                    title: _ctx.sharing.title,
                                    description: _ctx.sharing.description,
                                    quote: _ctx.sharing.quote,
                                    hashtags: _ctx.sharing.hashtags,
                                    twitterUser: _ctx.sharing.twitterUser,
                                    class: "btn btn-sm btn-seq-blue",
                                    style: { backgroundColor: network.color, borderColor: network.color }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("i", {
                                        class: [network.icon, "me-2"]
                                      }, null, 2),
                                      _createTextVNode(" Share with " + _toDisplayString(network.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["network", "url", "title", "description", "quote", "hashtags", "twitterUser", "style"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_31, [
          _createVNode("table", _hoisted_32, [
            _hoisted_33,
            _createVNode("tbody", null, [
              (_ctx.list.length === 0)
                ? (_openBlock(), _createBlock("tr", _hoisted_34, [
                    _hoisted_35
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_36, [
                    _createVNode("span", _hoisted_37, _toDisplayString(index + 1), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("span", _hoisted_39, [
                        _createVNode("span", _hoisted_40, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_41, _toDisplayString(item.nickname), 1),
                        _createVNode("div", _hoisted_42, _toDisplayString(item.email), 1),
                        _createVNode("div", _hoisted_43, _toDisplayString(item.cpnumber), 1),
                        _createVNode("div", _hoisted_44, [
                          _createVNode("div", _hoisted_45, [
                            (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (star) => {
                              return _createVNode("div", {
                                key: 'star-' + index + '-' + star,
                                class: ["rating-label me-1", item.howimportant >= star ? 'checked' : '']
                              }, [
                                _hoisted_46
                              ], 2)
                            }), 64))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("td", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (star) => {
                        return _createVNode("div", {
                          key: 'desk-star-' + index + '-' + star,
                          class: ["rating-label me-1", item.howimportant >= star ? 'checked' : '']
                        }, [
                          _hoisted_49
                        ], 2)
                      }), 64))
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_50, _toDisplayString(item.allocated_budget), 1),
                    _createVNode("div", _hoisted_51, _toDisplayString(item.coverage_people) + " people", 1)
                  ]),
                  _createVNode("td", _hoisted_52, [
                    _createVNode("div", _hoisted_53, _toDisplayString(item.coverage_people), 1)
                  ]),
                  _createVNode("td", _hoisted_54, [
                    _createVNode("span", {
                      class: ["seq-badge", item.stayphil.toUpperCase() === 'YES' ? 'seq-badge--success' : 'seq-badge--pending']
                    }, _toDisplayString(item.stayphil.toUpperCase()), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}